import { EntityTypes } from 'constants/entities';
import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { selectSession } from './session';

const session = selectSession;
const token = (state: RootState, token?) => token || state.state[EntityTypes.TOKEN];

export const selectToken = createSelector([session, token], (session, token) => {
  return session.tokens[token];
});
